<template>
  <!-- 用户管理- 用户关联-->
  <div class="benefit-statistical-box">
    <!-- header头部 -->
    <h3>用户关联</h3>
    <br />
    <header>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item style="margin-left: 20px">
          <el-input
              v-model.trim="query.user_id"
              placeholder="请输入用户id"
          ></el-input>
        </el-form-item>
        <el-form-item label="时间段:">
          <el-date-picker
              v-model="query.start_time"
              type="datetime"
              placeholder="开始时间"
              value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
          -
          <el-date-picker
              v-model="query.end_time"
              type="datetime"
              placeholder="结束时间"
              value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-select v-model="query.type">
            <el-option label="普通" :value="1"></el-option>
            <el-option label="排除0充值" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getData(1)">搜索</el-button>
        </el-form-item>
      </el-form>
    </header>
    <!-- body内容 -->
    <div class="body-box">
      <el-table
          :data="dataList"
          v-loading="loading"
      >
        <el-table-column
            prop="id"
            label="用户ID"
            width="100px"
        ></el-table-column>
        <el-table-column prop="id" label="用户所属">
          <template slot-scope="{ row }">
            <span v-if="row.user_ip_in == 1">ip相同 | </span>
            <span v-if="row.user_realname_in == 1">实名信息相同</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="用户名"></el-table-column>
        <el-table-column prop="phone" label="电话"></el-table-column>
        <el-table-column prop="id" label="主播？">
          <template slot-scope="{ row }">
            <span v-if="row.type == 2">主播</span>
            <span v-else>否</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="recharge_amount"
            label="充值金额"
        ></el-table-column>
        <el-table-column
            prop="backpack_amount"
            label="背包余额"
        ></el-table-column>
        <el-table-column
            prop="account_balance"
            label="钻石余额"
        ></el-table-column>
        <el-table-column
            prop="shop_balance"
            label="商城余额"
        ></el-table-column>
        <el-table-column
            prop="exp_boxes_price"
            label="钥匙价值"
        ></el-table-column>
        <el-table-column
            prop="extract_get_out_amount"
            label="提取金额"
        ></el-table-column>
        <el-table-column
            prop="extract_transfer_amount"
            label="转赠金额"
        ></el-table-column>
        <el-table-column
            prop="transfer2_amount"
            label="转赠2"
        ></el-table-column>
        <el-table-column
            prop="profit_amount"
            label="盈亏"
        ></el-table-column>
        <el-table-column
            prop="compensate_amount"
            label="补偿"
        ></el-table-column>
        <el-table-column label="操作" width="200" fixed="right">
          <template slot-scope="{ row }">
            <el-row style="margin-bottom: 10px" v-if="row.id">
              <el-col :span="12">
                <el-button type="primary" size="small" @click="compensateBalance(row)">补偿</el-button>
              </el-col>
            </el-row>
            <el-row style="margin-bottom: 10px" v-if="row.id">
              <el-col :span="12">
                <el-button type="primary" size="small" @click="showCompensateLog(row)">查看补偿</el-button>
              </el-col>
            </el-row>
          </template>
        </el-table-column>

      </el-table>
    </div>

    <el-dialog :visible="visibleChange" title="补偿" @close="visibleChange = false" width="400px"
               :close-on-click-modal="false">
      <el-form label-width="80px">
        <el-form-item prop="name" label="金额">
          <el-input size="small" v-model="balance"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="visibleChange = false">取 消</el-button>
        <el-button size="small" type="primary" @click="changeBalance" :loading="buttonLoading">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible="visibleLog" title="补偿" @close="visibleLog = false" width="400px"
               :close-on-click-modal="false">
      <el-table
          :data="dataLogList"
          v-loading="loading"
      >
        <el-table-column
            prop="money"
            label="金额"
        ></el-table-column>
        <el-table-column
            prop="created_at"
            label="时间"
        ></el-table-column>
      </el-table>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="visibleLog = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { server, delData, patchData, postData, getData, postApiData, getApiData } from '@/http'
export default {
  data() {
    return {
      loading: false,
      query: {
        user_id: undefined,
        start_time: undefined,
        end_time: undefined,
        type: 1
      },
      dataList: undefined,
      visibleChange: false,
      buttonLoading: false,
      balance: '',
      user_id: '',
      visibleLog: false,
      dataLogList: undefined
    }
  },
  created() {

  },
  methods: {
    getData() {
      //获取数据
      if (!this.query.user_id) {
        this.$message.error("用户id必填")
        return
      }
      let params = this.query
      this.loading = true
      getApiData(`user_id_card`, params)
          .then(res => {
            this.dataList = res.data
          }).finally(() => {
        this.loading = false
      })
    },
    // 补偿余额
    compensateBalance(raw) {
      this.user_id = raw.id;
      this.visibleChange = true;
    },
    changeBalance() {
      // 修改余额
      this.buttonLoading = true
      postData(`compensate_balance`, {user_id: this.user_id, balance: this.balance})
          .then(res => {
            if (res.code) {
              this.$message.success(res.message)
              this.visibleChange = false
              this.getData()
            } else {
              this.$message.error(res.message)
            }
          })
          .finally(() => {
            this.buttonLoading = false
          })
    },
    showCompensateLog(row) {
      this.loading = true
      this.visibleLog = true
      getApiData(`get_compensate_list`, {user_id: row.id})
          .then(res => {
            this.dataLogList = res.data
          }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
<style lang="less" scoped>
</style>
